import { Box } from '@chakra-ui/react'
import { FC } from 'react'

const MarkdownTh: FC = (props) => {
  return <Box as="th" p="2" border="1px solid" borderColor="gray.100" {...props} />
}

export default MarkdownTh
